import type { Editor } from '@tiptap/react';
import { EditorContent } from '@tiptap/react';
import { StyledRichTextEditorContent } from './styled';

interface Props {
  editor: Editor;
}

export const RichTextEditorInput = ({ editor }: Props) => (
  <StyledRichTextEditorContent>
    <EditorContent editor={editor} />
  </StyledRichTextEditorContent>
);
